
<template>
    <div class="loading2" :style="{width, height}">
        <img src="../../../assets/img/loading.gif" alt=""/>
    </div>
</template>
<script>
    export default {
        props: ['width','height']
    }
</script>